import api from './auth.api';

export interface SiteSummary {
  id: number;
  crmSiteId: number;
  name: string;
  timezone: string;
  isActive: boolean;
  subscriberCount: number;
  invoiceCount: number;
  unpaidInvoiceCount: number;
  lastInvoiceSyncAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const sitesApi = {
  list: async (): Promise<{ sites: SiteSummary[]; total: number }> => {
    const response = await api.get<{
      success: boolean;
      data: { sites: SiteSummary[]; total: number };
    }>('/sites');
    return response.data.data;
  },
};

export default sitesApi;
